import React from 'react'
import './productlist.css'
const Productlist = () => {
    return (
        <div className='Productlist'>

            <div className="ProductlistCol">
                <div className="ProductlistColHeading">NEW PRODUCTS </div><div className="ProductlistColHeadingLine"></div>

                <div className="ProductlistColRow">
                   <a href=""> <img src="https://www.pixel-industry.com/html/musician/musician-html/img/shop/shop-widget-img-01.jpg" alt="" /></a>
                    <div>
                        <div className="ProductlistColRowTitle"><a href="">ROCKABILLY SHIRT</a></div>
                        <div className="ProductlistColRowPrice">$40</div>
                    </div>
                </div>
                <div className="ProductlistColRow">
                <a href=""><img src="https://www.pixel-industry.com/html/musician/musician-html/img/shop/shop-widget-img-02.jpg" alt="" /></a>
                    <div>
                        <div className="ProductlistColRowTitle"><a href="">ROCK 'N' ROLL BAG</a></div>
                        <div className="ProductlistColRowPrice">$80</div>
                    </div>
                </div>
                <div className="ProductlistColRow">
                <a href=""><img src="https://www.pixel-industry.com/html/musician/musician-html/img/shop/shop-widget-img-03.jpg" alt="" /></a>
                    <div>
                        <div className="ProductlistColRowTitle"><a href="">ROCKABILLY HOODY</a></div>
                        <div className="ProductlistColRowPrice">$120</div>
                    </div>
                </div>

            </div>


            <div className="ProductlistCol">
                <div className="ProductlistColHeading">ON SALE</div><div className="ProductlistColHeadingLine"></div>

                <div className="ProductlistColRow">
                <a href=""> <img src="https://www.pixel-industry.com/html/musician/musician-html/img/shop/shop-widget-img-04.jpg" alt="" /></a>
                    <div>
                        <div className="ProductlistColRowTitle"><a href="">LIVE AT BERLIN</a></div>
                        <div className="ProductlistColRowPrice">$40 $20</div>
                    </div>
                </div>
                <div className="ProductlistColRow">
                <a href="">  <img src="https://www.pixel-industry.com/html/musician/musician-html/img/shop/shop-widget-img-05.jpg" alt="" /></a>
                    <div>

                        <div className="ProductlistColRowTitle"><a href="">ROCK 'N' ROLL </a></div>
                        <div className="ProductlistColRowPrice">$40</div>
                    </div>
                </div>
                <div className="ProductlistColRow">
                <a href=""><img src="https://www.pixel-industry.com/html/musician/musician-html/img/shop/shop-widget-img-06.jpg" alt="" /></a>
                    <div>

                        <div className="ProductlistColRowTitle"><a href="">BEER GLASS 6 PACK</a></div>
                        <div className="ProductlistColRowPrice">$120</div>
                    </div>
                </div>

            </div>

            <div className="ProductlistCol">
                <div className="ProductlistColHeading">FEATURED</div><div className="ProductlistColHeadingLine"></div>

                <div className="ProductlistColRow">
                <a href=""><img src="https://www.pixel-industry.com/html/musician/musician-html/img/shop/shop-widget-img-07.jpg" alt="" /></a>
                    <div>

                        <div className="ProductlistColRowTitle"><a href="">LONG LIVE ROCKS</a></div>
                        <div className="ProductlistColRowPrice">$40</div>
                    </div>
                </div>
                <div className="ProductlistColRow">
                <a href=""><img src="https://www.pixel-industry.com/html/musician/musician-html/img/shop/shop-widget-img-08.jpg" alt="" /></a>
                    <div>

                        <div className="ProductlistColRowTitle"><a href="">ROCK STAR MUG </a></div>
                        <div className="ProductlistColRowPrice">$40</div>
                    </div>
                </div>
                <div className="ProductlistColRow">
                <a href=""><img src="https://www.pixel-industry.com/html/musician/musician-html/img/shop/shop-widget-img-09.jpg" alt="" /></a>
                    <div>

                        <div className="ProductlistColRowTitle"><a href="">GO LOUD OR GO MORE</a></div>
                        <div className="ProductlistColRowPrice">$60</div>
                    </div>
                </div>

            </div>

            <div className="ProductlistCol">
                <div className="ProductlistColHeading">FEATURED</div><div className="ProductlistColHeadingLine"></div>

                <div className="ProductlistColRow">
                <a href=""><img src="https://www.pixel-industry.com/html/musician/musician-html/img/shop/shop-widget-img-10.jpg" alt="" /></a>

                    <div>

                        <div className="ProductlistColRowTitle"><a href="">ROCK STAR</a></div>
                        <div className="ProductlistColRowPrice">$40</div>
                    </div>
                </div>
                <div className="ProductlistColRow">
                <a href=""><img src="https://www.pixel-industry.com/html/musician/musician-html/img/shop/shop-widget-img-11.jpg" alt="" /></a>
                    <div>

                        <div className="ProductlistColRowTitle"><a href="">LIVE TO RIDE HOODY </a></div>
                        <div className="ProductlistColRowPrice">$40</div>
                    </div>
                </div>
                <div className="ProductlistColRow">
                <a href=""><img src="https://www.pixel-industry.com/html/musician/musician-html/img/shop/shop-widget-img-09.jpg" alt="" /></a>
                    <div>

                        <div className="ProductlistColRowTitle"><a href="">GO LOUD OR GO MORE</a></div>
                        <div className="ProductlistColRowPrice">$120</div>
                    </div>
                </div>

            </div>


        </div>
    )
}

export default Productlist
